import { Component } from '@angular/core';

@Component({
	selector: 'app-apps',
	templateUrl: './apps.component.html',
	styleUrls: ['./apps.component.css']
})
export class AppsComponent {
	googlePlayURL = 'https://play.google.com/store/apps/details?id=com.smartchargetech.telemetrics';
	appStoreURL = 'https://apps.apple.com/us/app/id6741804567';
}
